import React from 'react';

import { postWebUiApi } from '../../api';
import { WebUiAlert } from '../../components/alert';
import WebUiPageWrapper from '../../components/page-wrapper';

type Lease = { ip?: string; mac?: string; time?: string | number };
type LeaseResponse = { static?: Lease[]; dynamic?: Lease[] };

export default function WebUiStatusDhcpLeasesPage() {
  const [rows, setRows] = React.useState<
    Array<Lease & { type: 'static' | 'dynamic' }>
  >([]);
  const [error, setError] = React.useState<string | null>(null);

  const reload = React.useCallback(async () => {
    const data = await postWebUiApi<LeaseResponse>({
      service: 'dhcp',
      access: 'get',
      command: 'get active leases',
    });
    const st = (data.static ?? []).map((x) => ({
      ...x,
      type: 'static' as const,
    }));
    const dy = (data.dynamic ?? []).map((x) => ({
      ...x,
      type: 'dynamic' as const,
    }));
    setRows([...st, ...dy]);
  }, []);

  React.useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        await reload();
        if (alive) setError(null);
      } catch (err) {
        if (alive) setError((err as Error).message);
      }
    };
    load().catch(() => {});
    const t = window.setInterval(() => load().catch(() => {}), 5000);
    return () => {
      alive = false;
      window.clearInterval(t);
    };
  }, [reload]);

  return (
    <WebUiPageWrapper titleList={['Status', 'DHCP Leases']}>
      {error ? <WebUiAlert type="error" message={error} /> : null}
      <div className="w-full">
        <table className="webui-table w-full">
          <thead>
            <tr className="webui-table-row-head">
              <th className="text-center">IP Address</th>
              <th className="text-center">MAC Address</th>
              <th className="text-center">Type</th>
              <th className="text-center">Leasetime (s)</th>
            </tr>
          </thead>
          <tbody>
            {!rows.length ? (
              <tr className="webui-table-row-content">
                <td
                  colSpan={4}
                  className="text-center text-sm italic text-webui-muted"
                >
                  No active DHCP leases.
                </td>
              </tr>
            ) : (
              rows.map((r, i) => (
                <tr
                  key={`${r.ip}-${r.mac}-${i}`}
                  className="webui-table-row-content"
                >
                  <td className="text-center">{r.ip ?? ''}</td>
                  <td className="text-center">{r.mac ?? ''}</td>
                  <td className="text-center">{r.type}</td>
                  <td className="text-center">{String(r.time ?? '')}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </WebUiPageWrapper>
  );
}
